/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext } from "react";
import { graphql, Link } from "gatsby";
import Img from "gatsby-image";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import Footer from "~components/Footer";
import GradientBorder from "~components/GradientBorder";
import Layout from "~components/Layout";
import SEO from "~components/SEO";

const Bag = ({ data, location }) => {
  const {
    cart,
    checkout,
    decreaseQuantityByCartIndex,
    increaseQuantityByCartIndex,
    removeFromCartByIndex
  } = useContext(AppContext);
  const { device } = useContext(DocumentContext);

  //

  const cms = data.sanityBag;

  //
  // cart parsing

  const cartList = [];
  const shopifyProducts = []; // used for checkout analytics

  let cartCount = 0;

  if (cart?.[0] && data?.allSanityProduct?.edges?.[0]) {
    cart.forEach(cartItem => {
      data.allSanityProduct.edges.forEach(({ node }) => {
        const sanityProduct = node;

        if (sanityProduct?.shopifyProduct?.variants?.[0]) {
          // used for checkout analytics
          shopifyProducts.push(sanityProduct.shopifyProduct);

          sanityProduct.shopifyProduct.variants.forEach(shopifyVariant => {
            if (shopifyVariant.id === cartItem.variantId) {
              const price = parseFloat(shopifyVariant.price).toFixed(2);
              const lineItemPrice = parseFloat(
                price * cartItem.quantity
              ).toFixed(2);

              cartCount += cartItem.quantity;

              //

              if (sanityProduct?.collections?.[0]) {
                sanityProduct.collections.forEach(collection => {
                  if (
                    !sanityProduct?.shopifyProduct?.productType &&
                    collection.handle !== `best-sellers`
                  ) {
                    sanityProduct.shopifyProduct.productType = collection.title;
                  }
                });
              }

              //

              cartList.push({
                data: sanityProduct,
                quantity: cartItem.quantity,
                price,
                lineItemPrice
              });
            }
          });
        }
      });
    });
  }

  //

  return (
    <>
      <SEO
        customTitle={cms?.title}
        customDescription={cms?.seoDescription}
        customKeywords={cms?.seoKeywords}
        path={location.pathname}
      />

      <Layout className="bag-page w-full relative pt-v8 bg-bone">
        <section className="grid">
          <p className="grid-end-12 b2">
            <Link to="/" className="hover-underline">
              Home
            </Link>
            <span> . Bag</span>
          </p>
        </section>

        <section className="grid items-start justify-start pt-12 md:pt-0">
          <header className="animation-appear-down-slow animation-delay-1 grid-end-12 md:grid-end-6 md:grid-start-4 md:flex md:items-center md:justify-between">
            <div className="relative md:flex md:items-center text-center md:text-left">
              <h1 className="f2">{cms?.title || `Your Bag`}</h1>
              <h3 className="mt-4 md:mt-0 mb-12 md:mb-0 md:ml-8 b1">
                {cartCount} item{cartCount !== 1 ? `s` : ``}
              </h3>
            </div>

            <Button
              className={`${
                cartCount === 0 ? `opacity-50 pointer-events-none` : ``
              } ${device === `desktop` ? `` : `mx-auto`} px-4`}
              color="white"
              onClick={() => {
                if (cartCount > 0) {
                  checkout(shopifyProducts);
                }
              }}
            >
              <span className="block f-button">Proceed to Checkout</span>
            </Button>
          </header>

          <article className="bag-page__list animation-appear-down-slow animation-delay-2 relative grid-end-12 md:grid-end-6 md:grid-start-4">
            <div className="w-full relative flex items-center justify-between mt-8 pb-2">
              <h3 className="b2">Product</h3>
              <h3 className="b2">Price</h3>

              <GradientBorder />
            </div>

            {(cartList?.[0] && (
              <ul className="w-full">
                {cartList.map((cartItem, cartItemIndex) => {
                  const { shopifyProduct } = cartItem?.data;
                  const key = shopifyProduct?.variants?.[0]?.id;

                  //
                  // console.log(shopifyProduct);

                  return (
                    <li key={key} className="relative flex pt-6 pb-10">
                      <div className="w-full md:w-4/6 relative flex">
                        <Img
                          className="w-1/3 md:w-1/4 relative block"
                          fluid={cartItem.data.image.asset.fluid}
                          alt={cartItem.data.title}
                        />

                        <div className="w-full relative md:flex flex-col items-start justify-between pl-8">
                          <div>
                            <h2 className="b1">{cartItem.data.title}</h2>
                            <h2 className="b2">${cartItem.price}</h2>
                          </div>

                          <button
                            type="button"
                            className="block mt-2 md:mt-0 caption text-left underline"
                            onClick={() => {
                              removeFromCartByIndex(
                                cartItemIndex,
                                shopifyProduct
                              );
                            }}
                          >
                            Remove
                          </button>

                          <div className="w-full relative flex md:hidden justify-between pt-4">
                            <div className="relative inline-flex bg-white border">
                              <button
                                type="button"
                                className="p-3 caption"
                                style={{ lineHeight: 1.2 }}
                                onClick={() =>
                                  decreaseQuantityByCartIndex(
                                    cartItemIndex,
                                    shopifyProduct
                                  )
                                }
                              >
                                -
                              </button>

                              <h4
                                className="w-5 relative py-3 caption text-center"
                                style={{ lineHeight: 1.2 }}
                              >
                                {cartItem.quantity}
                              </h4>

                              <button
                                type="button"
                                className="p-3 caption"
                                style={{ lineHeight: 1.2 }}
                                onClick={() =>
                                  increaseQuantityByCartIndex(
                                    cartItemIndex,
                                    shopifyProduct
                                  )
                                }
                              >
                                +
                              </button>
                            </div>

                            <h3 className="b1">${cartItem.lineItemPrice}</h3>
                          </div>
                        </div>
                      </div>

                      <div className="w-2/6 h-12 relative hidden md:flex items-center justify-between">
                        <div className="relative hidden md:flex bg-white border">
                          <button
                            type="button"
                            className="p-3 caption"
                            style={{ lineHeight: 1.2 }}
                            onClick={() => {
                              decreaseQuantityByCartIndex(
                                cartItemIndex,
                                shopifyProduct
                              );
                            }}
                          >
                            -
                          </button>

                          <h4
                            className="w-5 relative py-3 caption text-center"
                            style={{ lineHeight: 1.2 }}
                          >
                            {cartItem.quantity}
                          </h4>

                          <button
                            type="button"
                            className="p-3 caption"
                            style={{ lineHeight: 1.2 }}
                            onClick={() =>
                              increaseQuantityByCartIndex(
                                cartItemIndex,
                                shopifyProduct
                              )
                            }
                          >
                            +
                          </button>
                        </div>

                        <h3 className="b1">${cartItem.lineItemPrice}</h3>
                      </div>

                      <GradientBorder />
                    </li>
                  );
                })}
              </ul>
            )) || (
              <p className="animation-appear-down-slow pt-24 pb-32 b1 text-center">
                Your bag is empty.
              </p>
            )}

            <div className="grid-end-12 md:grid-end-6 md:grid-start-4 relative mt-v4 flex items-center justify-center">
              <Link to="/collections">
                <Button className="px-4" color="white">
                  <span className="block f-button">Continue shopping</span>
                </Button>
              </Link>
            </div>
          </article>
        </section>
      </Layout>

      <Footer />
    </>
  );
};

export default Bag;

export const query = graphql`
  query Bag {
    sanityBag {
      title
      seoDescription
      seoKeywords
    }

    allSanityProduct {
      edges {
        node {
          title
          handle

          collections {
            title
            handle
          }

          image {
            asset {
              fluid {
                ...GatsbySanityImageFluid_noBase64
              }
            }
            altText
          }

          shopifyProduct {
            id
            title
            description
            handle
            images {
              originalSrc
            }
            productType
            vendor
            variants {
              id
              sku
              title
              image {
                originalSrc
              }
              price
              presentmentPrices {
                edges {
                  node {
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
              }
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  }
`;
